import { render, staticRenderFns } from "./site-review.vue?vue&type=template&id=5741b504&"
import script from "./site-review.vue?vue&type=script&lang=js&"
export * from "./site-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports